/* eslint-disable  import/no-unresolved */
window.Vue = require("vueOriginal");
window.Vuex = require("vuexOriginal");
window.VueI18n = require("vueI18nOriginal");
window.vuejsDatepicker = require("@vuepic/vue-datepicker");
